import React from "react";
import "./submit-score-button.css";

import { BsCheckLg } from "react-icons/bs";

const SubmitScores = () => {
  return (
    <button className="submit-button">
      <BsCheckLg />
    </button>
  );
};

export default SubmitScores;
